// extracted by mini-css-extract-plugin
export default {"links":"i42sxeCB8uHWWSkzJwAP","acceptAll":"cIPraO0UDB9csVZReIBD"};